import { PdfEditorType } from '../enums/pdf-editor-type';
import { PdfEditor } from '../models/pdf-editor';
import { WebdokuService } from '../../web-doku/webdoku.service';

export class PdfSettings {
  public disableEditing = false;
  public disableDownload = false;
  public disablePrinting = false;

  // todo: TRANS: localize editor names
  public availableEditors: PdfEditor[] = [
    new PdfEditor(PdfEditorType.Editor, 'SETTINGS.EDITOR', true),
    new PdfEditor(PdfEditorType.Viewer, 'SETTINGS.VIEWER', false)
  ];

  private currentPdfEditor = 0;

  constructor(private webDokuService: WebdokuService) {}

  /**
   * gets the number of the currently selected editor
   */
  public getSelectedEditor() {
    return this.currentPdfEditor;
  }

  /**
   * selects the new editor
   * @param name editor name
   */
  public setEditorByName(name: string) {
    if (name == null || name == '') {
      return;
    }
    name = name.toLowerCase();
    if (name == 'editor') {
      this.setSelectedEditor(0);
      return;
    }
    // viewer
    this.setSelectedEditor(1);
  }

  /**
   * selects the new editor
   * @param index editor number
   */
  public setSelectedEditor(index: number) {
    if (index < 0 || index >= this.availableEditors.length) {
      return;
    }
    this.currentPdfEditor = index;
  }

  public currentEditor(): PdfEditor {
    return this.availableEditors[this.currentPdfEditor];
  }

  /**
   * is currently editing possible
   * dependend of edit setting and selected pdf editor
   */
  public isEditingEnabled(): boolean {
    // check user/webDoku rights for editing allowed
    if (!this.webDokuService.currentWebDokuRedliningAllowed) {
      return false;
    }
    return !this.disableEditing && this.editorAllowsEditing();
  }

  /**
   * does current editor allow editing
   */
  public editorAllowsEditing(): boolean {
    return this.currentEditor().allowEditing;
  }
}
